import classNames from "classnames";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { RouterConfig } from "@shared/lib/routerConfig";
import { LogoProps } from "./types";
import classes from "./logo.module.scss";

export const Logo = ({ className, isMono }: LogoProps & { isMono?: boolean }) => {
    return (
        <a
            className={classNames(classes.logo, className)}
            href={RouterConfig.MAIN}
            aria-label={PROJECT_NAME}
        >
            <svg
                className={classes.logo__wrapper}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 69 36"
            >
                <path
                    className={classNames({ [classes.logo__bg]: isMono })}
                    fill={"#3B85F7"}
                    d="M.487 12.795A9.313 9.313 0 0 1 9.3 3.008L57.39.488A9.313 9.313 0 0 1 67.175 9.3l.729 13.905a9.313 9.313 0 0 1-8.813 9.788L4.61 35.847a2.91 2.91 0 0 1-3.059-2.754L.487 12.795Z"
                />
                <path
                    className={classNames({ [classes.logo__text]: isMono })}
                    fill={"#FFFFFF"}
                    d="m11.443 28.322-.946-18.063 3.284-.172.946 18.063-3.284.172ZM18.367 27.959l-.671-12.799 3.284-.172.67 12.799-3.283.172Zm.892-14.381c-.59.03-1.104-.132-1.541-.489-.42-.357-.645-.846-.678-1.465-.032-.62.141-1.129.521-1.528.397-.4.891-.616 1.482-.647.608-.032 1.122.131 1.542.489.42.357.645.845.677 1.465.033.619-.14 1.128-.52 1.528-.38.4-.874.615-1.483.647ZM25.29 27.596l-.947-18.062 3.284-.173.524 9.986.469-.024 4.027-4.946 4.275-.224-5.645 6.505 6.524 6.282-4.223.222-4.801-4.846-.47.025.267 5.083-3.284.172ZM42.713 26.683 37.923 14.1l3.493-.183 3.544 10.268.47-.025 2.45-10.582 3.493-.183-3.447 13.015-5.213.273ZM54.281 26.077l-.67-12.799 3.284-.172.67 12.799-3.284.172Zm.893-14.382c-.59.031-1.104-.131-1.541-.488-.42-.357-.646-.846-.678-1.465-.033-.62.141-1.129.52-1.528.398-.4.892-.616 1.483-.647.608-.032 1.122.13 1.541.488.42.358.646.846.678 1.466.033.619-.141 1.128-.52 1.527-.38.4-.875.616-1.483.647Z"
                />
            </svg>
        </a>
    );
};